export default __webpack_public_path__ + "dist/media/Plus.c4c4f3ef.svg";